import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private storageService: StorageService, private router: Router) { }

  canActivate() {
    var token = this.storageService.getItem("token");

    if (token) {
      return true;
    }

    if (token == null && token == undefined) {
      this.router.navigate(['/auth/login']);
    }

    return false;
  }
}
